import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {NgForm} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {delay, distinctUntilChanged, takeUntil, tap} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {TemplateService} from '../../../shared/services/template.service';
import {Template} from '../../../shared/interface/template';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterService} from '../../../shared/services/filter.service';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../shared/ngrx/reducers';
import {getCurrentRouteState} from '../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../shared/ngrx/route-serializer';

@Component({
  selector: 'app-all-template-list',
  templateUrl: './all-template-list.component.html',
  styleUrls: ['./all-template-list.component.scss']
})
export class AllTemplateListComponent implements AfterViewInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  templates: Template[] = [];
  displayedColumns: string[] = ['name', 'type', 'createdAt', 'user', 'contractType', 'formOfBusiness', 'insuranceCompany', 'company', 'actions'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private templateService: TemplateService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.templateService.getTemplateListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<Template>) => {
          this.templates = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$name: 'string',
      type: 'int',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      username: 'string',
      contractType: 'int',
      company: 'int',
      in$insuranceCompany: 'int[]',
      gte$validFrom: 'date',
      lte$validFrom: 'date',
    }, filters);
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })]);
      });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.templateService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  downloadFile(uuid: string): void {
    this.templateService.downloadFile(uuid);
  }

  deleteFile(uuid: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć szablon?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.templateService.deleteFile(uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto szablon', '', {duration: 2000});
            this.loadListData();
          });
      }
    });
  }

  downloadReport(): void {
    this.templateService.downloadReport(this.initialFilters);
  }
  controlTest(): boolean{
    if ( window.location.href.includes('rejestracje')){
      return true;
    }
    return false;
  }
}
